export default {"src":"/_next/static/media/CAR.aa2d587d.svg","height":18,"width":18};